/**
 * Registriert Relation WebComponents
 */
import { RelationConfigMenu } from './relation-config-menu';

export function registerRelationEffects() {
  if (!customElements.get('relation-config-menu')) {
    customElements.define('relation-config-menu', RelationConfigMenu);
  }
}

// Auto-register
registerRelationEffects();
